import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { getArticlePhoto, useArticleName } from '@/models/article';
import { ArticleWithRelations } from '@/models/request';
import { useDatabaseTranslation } from '@/services/i18n';
import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

import './ArticleSummary.css';

const { block, element } = createBEMClasses('article-summary');

export const ArticleSummary = ({
  article,
  size = 'medium',
}: {
  article: ArticleWithRelations;
  size?: 'small' | 'medium';
}) => {
  const { _db } = useDatabaseTranslation();
  const articleName = useArticleName({ article, type: 'short' });
  const articleSize = article.size ? _db(article.size) : undefined;
  const { isMobile } = useViewPort();

  return (
    <Stack row gap="0.5rem" alignItems="center" flexWrap="nowrap" className={block()}>
      <img className={element('photo', { size })} src={getArticlePhoto(article)?.url} alt="" />
      <Stack flexWrap="nowrap" style={{ overflow: 'hidden' }}>
        <p className={element('article-name')}>{articleName}</p>
        {!!(article.color || articleSize) && (
          <Paragraph size={isMobile ? '100' : '200'}>
            {!!article.color && _db(article.color)}
            {!!article.color && !!articleSize && ' • '}
            {!!articleSize && (
              <Trans id="client.components.article-summary.size">Size {articleSize}</Trans>
            )}
          </Paragraph>
        )}
      </Stack>
    </Stack>
  );
};
